import { render } from "./Research.vue?vue&type=template&id=966a2608&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"

import "./Research.vue?vue&type=style&index=0&id=966a2608&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-966a2608"

export default script